import React, { useCallback, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useChangePasswordMutation } from '@@/services/auth';
import ChangePasswordForm, {
  schema,
} from '@@/components/Forms/ChangePasswordForm';

const ChangePasswordPage: React.FC = () => {
  const navigation = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') as string;

  const form = useForm<{ password: string }>({
    resolver: yupResolver(schema),
    mode: 'onBlur',
  });

  const [changePassword, { isSuccess, isError }] = useChangePasswordMutation();

  const onSubmit = useCallback(
    (data: { password: string }) => {
      changePassword({ ...data, token });
    },
    [changePassword],
  );

  useEffect(() => {
    if (isSuccess) {
      form.reset();
      toast.success('Votre mot de passe a bien été modifié');
      navigation('/signin');
    }
  }, [isSuccess, form.reset]);

  useEffect(() => {
    if (!token) {
      navigation('/reset-password');
    }
  }, [token]);

  if (isError) {
    return (
      <div className="m-6 mx-auto sm:w-[500px]">
        <p className="text-main font-main mb-10 mx-4">
          La requête a expiré. Veuillez refaire une demande de réinitialisation
          de mot de passe&nbsp;
          <Link
            to="/reset-password"
            className="text-blue-500 text-lg underline"
          >
            ici
          </Link>
        </p>
      </div>
    );
  }

  return (
    <div className="m-6 mx-auto sm:w-[500px]">
      <p className="text-main font-main mb-10">
        Veuillez entrer un nouveau mot de passe
      </p>
      <ChangePasswordForm form={form} />

      <button
        type="button"
        className="mt-10 py-2 px-3 bg-cyan-400 text-white rounded-xl font-main text-base w-fit"
        onClick={form.handleSubmit(onSubmit)}
        disabled={form.formState.isSubmitting}
      >
        <span className="ml-2">Valider</span>
      </button>
    </div>
  );
};

export default ChangePasswordPage;
